import Base from './base'
import urls from 'config/urls'

class Report extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.report.find,
      data: opts
    })
  }

  updateComment (opts) {
    return this.httpPost({
      url: urls.report.updateComment,
      data: opts
    })
  }

  export (opts) {
    return this.httpDownload({
      url: urls.report.export,
      data: opts
    })
  }

  updateText (opts) {
    return this.httpPost({
      url: urls.report.updateText,
      data: opts
    })
  }
}

export default new Report



// WEBPACK FOOTER //
// ./src/models/report.js